import React from "react";
import { Button, Tooltip } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import { motion, AnimatePresence } from "framer-motion";
import { useLanguage } from "../../context/LanguageContext";

const LanguageSwitcher = () => {
  const {
    currentLanguage,
    changeLanguage,
    availableLanguages,
    isI18nReady,
  } = useLanguage();

  // Find current language object
  const currentIndex = availableLanguages.findIndex(
    (lang) => lang.code === currentLanguage
  );
  
  const currentLang = availableLanguages[currentIndex];

  // Function to cycle to the next language
  const handleToggle = () => {
    const nextIndex = (currentIndex + 1) % availableLanguages.length;
    const nextLang = availableLanguages[nextIndex];
    changeLanguage(nextLang.code);
  };

  if (!isI18nReady) {
    return (
      <Button
        type="text"
        icon={<GlobalOutlined className="animate-spin-slow" />}
        className="text-white opacity-50"
        disabled
      />
    );
  }

  return (
    <Tooltip title={` ${currentLang?.nativeName}`}>
      <Button
        type="text"
        onClick={handleToggle}
        className="flex items-center justify-center w-6 h-6 md:w-8 md:h-8 gap-2 bg-black/10 hover:bg-black/40 border-none text-secondary transition-all p-1  rounded-full"
      >
        <GlobalOutlined className="md:text-lg text-primary" />
{/*         
        <div className="overflow-hidden h-5 flex items-center">
          <AnimatePresence mode="wait">
            <motion.span
              key={currentLang?.code}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2, ease: "easeOut" }}
              className="text-sm font-semibold hidden sm:inline-block"
            >
              {currentLang?.code.toUpperCase()}
            </motion.span>
          </AnimatePresence>
        </div> */}
      </Button>
    </Tooltip>
  );
};

export default LanguageSwitcher;